<template>

        <div class="container settsPad has-text-centered has-text-white scrollableY">
             <div class="bottom20">&nbsp;</div>
            <H1 class="has-text-white is-size-3"><img src="@/assets/img/fourDotsLogo.png" width="24"/> PAYMENT INFO</H1>
            <div class="limitWidth top10 marginAutod has-text-centered">
              
                <div class="top10 bottom60">
                    <form class="form has-text-left" v-on:submit.prevent="onSubmit" v-show="!pmUpdated">
                        <div class="columns limitWidth" id="billingInfo">
                            
                        
                            <div class="column pmtSrcInfoDiv top10">
                                <div class="field  is-size-5">
                                    Billing Address:
                                </div>
                                <div class="field" :class="{formError: errors.first('BillingAddress') }">
                                    Address:
                                    <input type="text" class="input is-coolGreen billing-field" name="BillingAddress" v-validate="'required'" v-model="pmForm.address1" />
                                    <p class="help is-danger" >
                                        {{ errors.first('BillingAddress') }}
                                    </p>
                                </div>
                                <div class="field">
                                    <br />
                                    <input type="text" class="input is-coolGreen billing-field" name="BillingAddress2" v-model="pmForm.address2" />
                                </div>
                                <div class="field" :class="{formError: errors.first('BillingCity') }">
                                    City:
                                    <input type="text" class="input is-coolGreen billing-field" name="BillingCity" v-validate="'required'" v-model="pmForm.city"/>
                                    <p class="help is-danger" >
                                        {{ errors.first('BillingCity') }}
                                    </p>
                                </div>
                                <div class="field" :class="{formError: errors.first('BillingState') }">
                                    State/Province:
                                    <input type="text" class="input is-coolGreen billing-field" name="BillingState" v-validate="'required'" v-model="pmForm.state"/>
                                    <p class="help is-danger" >
                                        {{ errors.first('BillingState') }}
                                    </p>
                                </div>
                                <div class="field" :class="{formError: errors.first('BillingZip') }">
                                    Zip Code:
                                    <input type="text" class="input is-coolGreen billing-field" name="BillingZip" v-validate="'required'" v-model="pmForm.zip"/>
                                    <p class="help is-danger" >
                                        {{ errors.first('BillingZip') }}
                                    </p>
                                </div>
                                <div class="field" :class="{formError: errors.first('BillingCountry') }">
                                    Country:<br/>
                                    <div class="select is-coolGreen width100">
                                        <select name="BillingCountry" class="width100 billing-dropdown"  v-validate="'required'" v-model="pmForm.country">
                                            <option disabled value="">Select...</option>
                                            <option v-for="item in countries" :key="item.code" v-bind:value="item.code">{{item.name}}</option>
                                        </select>
                                    </div>
                                    <p class="help is-danger" >
                                        {{ errors.first('BillingCountry')}}
                                    </p>
                                </div>
                            </div>
                        
                        </div>

                        <div class="field  is-size-5 top40">
                            Card Information:
                        </div>

                        <div class="field top20">
                            <label >
                            <input type="radio" name="card" value="existing"  v-model="pmForm.existingCardOrNew" /> Existing Card ending in: *{{last4}}
                            </label>
                            <br>
                            <label>
                                <input type="radio" name="card" value="new"  v-model="pmForm.existingCardOrNew" id="newCardRadio" class="top20" /> Replace with other debit or credit card:
                            </label>
                        </div>

                        <div v-show="pmForm.existingCardOrNew == 'new'" >
                            <div class="has-text-white" v-if="$root.app.DEBUG">
                                <h4>
                                    4242424242424242 (accepted)<br />
                                    4000002500003155 (3d Secure)<br />
                                    4000000000000002 (declined)
                                </h4>
                            </div>
                            <div>
                                <div class="field top40">
                                    Name on Card:
                                    <input type="text" class="input is-coolGreen billing-field" v-model="pmForm.nameOnCard" />
                                </div>

                                <div class="field">
                                    Card Number:
                                    <div class="stripe-field">
                                        <div id="card-number-element"></div>
                                    </div>
                                </div>
                                <div class="field">
                                    Card Expiration:
                                    <div class="stripe-field">
                                        <div id="card-expiry-element"></div>
                                    </div>
                                </div>
                                <div class="field">
                                    Card CVC:
                                    <div class="stripe-field">
                                        <div id="card-cvc-element"></div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                

                        <div class="field top20">
                            <button type="submit" class="button is-coolGreen top10" id="submitBt">SUBMIT</button>&nbsp;
                            <button v-if="showCancel" class="button  top10" @click.prevent="onCancel">CANCEL</button>
                            <div class="has-text-danger has-text-weight-bold top10" v-show="showErrorsLine == true">Please correct the errors in the form and submit again.</div>
                            <div class="has-text-danger has-text-weight-bold top10" v-show="stripeError">{{ stripeError }}</div>
                        </div>
                        
                        
                    </form>

                    <div v-if="pmUpdated">
                        <div class="subtitle has-text-white">
                            Your payment info has been updated.
                        </div>

                        <div class="top20">
                            <button class="button" @click="$router.push('/')">HOME</button>
                        </div>

                    </div>
                </div>
            </div>
            <div id="pageBottom"></div>
        </div>
   
</template>

<script>

import countries from '../static/countries.js'
import { AZEventBus } from '../components/AZEventBus.js';
let loadStripe;

export default {
    //props: {goAfter: String},
    data: function() {

        let pmForm = {
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            existingCardOrNew: 'existing',
            nameOnCard: this.$root.app.userAttrs.given_name + ' ' + this.$root.app.userAttrs.family_name,
            showCancel: false,
        }

        return {
            initialized: false,
            countries,
            pmForm: pmForm,
            last4: '',
            pmUpdated: false,

            stripeError: '',
            showErrorsLine: false,
        }
    },
    mounted: async function() {

        if (this.$root.app.goAfterPmtSrc) {
            this.$root.app.goAfterPmtSrc = '';
            this.showCancel = true;
        }

        if(this.$root.app.doneFederating){
            this.initialize();
        }
        AZEventBus.$once('onFederate', msg => {
            this.initialize();
        });

        let stripeStyle = {
            base: {
                color: '#fff',
                fontSize: '16px',
                '::placeholder': {
                    color: '#888'
                },
                backgroundColor: '#333'
            }
        }

        // Initialize Stripe
        // Note, to even hit this page the following condition should evaluate to
        // true so it's a bit redundant, but no need to reinvent the wheel.  The
        // important part here (asided from the initialization) is Stripe needs
        // to be imported dynamically.
        if (!this.$root.app.inApp) {

            if (!loadStripe) {
                loadStripe = (await import('@stripe/stripe-js')).loadStripe;
            }

            this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUB_KEY);
            this.elements = this.stripe.elements();

            this.cardNumberElement = this.elements.create('cardNumber', {
                style: stripeStyle
            });
            this.cardNumberElement.mount('#card-number-element');

            this.cardExpiryElement = this.elements.create('cardExpiry', {
                style: stripeStyle
            });
            this.cardExpiryElement.mount('#card-expiry-element');

            this.cardCvcElement = this.elements.create('cardCvc', {
                style: stripeStyle
            });
            this.cardCvcElement.mount('#card-cvc-element');
        }

    },
    methods: {
        initialize: function() {
            if (this.initialized) {
                return
            }

            // Load user plan info.
            this.$root.app.apiClient.get('auth/account/paymentMethod', {}, (res) => {
                this.pmForm.address1 = res.address1;
                this.pmForm.address2 = res.address2;
                this.pmForm.city = res.city;
                this.pmForm.state = res.state;
                this.pmForm.zip = res.zip;
                this.pmForm.country = res.country;
                this.last4 = res.last4;
            }, (e) => {
                console.log(e);
            });

            this.initialized = true;
        },
        onSubmit: function() {

            this.$validator.validateAll().then(async success => {
                
                if (success) {
                    this.showErrorsLine = false;
                    az.addRemSpinner(true, 'id', 'submitBt');

                    // If it's the existing card, then only the billing address can be modified,
                    // and it's not necessary to use a SetupIntent.
                    if (this.pmForm.existingCardOrNew === 'existing') {
                        this.$root.app.apiClient.put('auth/account/paymentMethod', {
                            address1: this.pmForm.address1,
                            address2: this.pmForm.address2,
                            city: this.pmForm.city,
                            state: this.pmForm.state,
                            zip: this.pmForm.zip,
                            country: this.pmForm.country,
                        }, (res) => {
                            az.addRemSpinner(false, 'id', 'submitBt');
                            this.pmUpdated = true;
                        }, (e) => {
                            console.log(e);
                        });
                        //res = await res.json();
                    } else {
                        this.$root.app.apiClient.post('auth/account/paymentMethod', {}, (res) => {

                            this.stripe.confirmCardSetup(res.secret, {
                                payment_method: {
                                    card: this.cardNumberElement,
                                    billing_details: {
                                        name: this.pmForm.nameOnCard,
                                        address: {
                                            line1: this.pmForm.address1,
                                            line2: this.pmForm.address2,
                                            city: this.pmForm.city,
                                            state: this.pmForm.state,
                                            postal_code: this.pmForm.zip,
                                            country: this.pmForm.country,
                                        },
                                    }
                                }
                            }).then((result) => {
                                // This returns an error if, for instance, secure 3d fails or the card is declined.
                                // Secure 3D:
                                //  code: setup_intent_authentication_failure
                                //  message: We are unable to authenticate your payment method.
                                //           Please choose a different payment method and try again.
                                // Card declined:
                                //  code: card_declined
                                //  decline_code: generic_decline
                                //  message: Your card has been declined.
                                // https://docs.stripe.com/error-codes
                                if (result.error) {
                                    this.stripeError = result.error.message;
                                    //document.getElementById('pageBottom').scrollIntoView({behavior:'smooth'});
                                } else {
                                    if (this.showCancel) {
                                        this.$router.push({name: 'accsettings', params: {section: 'subscription', id: Math.random()}});
                                    } else {
                                        this.pmUpdated = true;
                                    }
                                }
                                az.addRemSpinner(false, 'id', 'submitBt');
                            });

                        }, (e) => {
                            console.log(e);
                        });

                    }

                } else {
                    this.showErrorsLine = true;
                    this.stripeError = '';
                    //document.getElementById('pageBottom').scrollIntoView({behavior:'smooth'});
                }
                
            });

        },
        onCancel: function() {
            this.$router.push({name: 'accsettings', params: {section: 'subscription', id: Math.random()}});
        }
    }

}
</script>
